export default __webpack_public_path__ + "static/img2-2db51126ed839c3cfe068cc9b036b098.png";